<pr-tag-list
  [tags]="patientNoteTags$ | async"
  (tagAdded)="addTag($event)"
 />
